









































































import { Component, Mixins } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { namespace, State } from 'vuex-class';
import { MetaInfo } from 'vue-meta';
import {
  Breadcrumbs as BreadcrumbsLayout,
  Extra as ExtraLayout,
} from '@/components/layout';
import PageError from '@/pages/404.vue';
import breadcrumbsMixin from '../mixins/breadcrumbs-mixin';
import {
  INIT,
  PROGRAM_CARD,
  PROGRAM_TITLE,
  PROFESSION_CARD,
  PROFESSION_TITLE,
  STORE_MODULE_NAME,
} from './consts';
import { Context, DictionaryType } from './types';
import createStoreModule from './store';
import {
  AppText,
  AppList,
  AppHeading,
  AppPicture,
  AppTypeIcon,
  AppCardsList,
  AppHtmlRender,
  AppBlockWrapper,
  AppCardTotalLayout,
  AppCardDescriptionBlockLayout,
} from '@/uikit';
import nameFromDictionary from '@/tools/nameFromDictionary';
import {
  CompetenceSidebar,
  CompetenceMain,
  MapedProfessionsType,
  ParsedEvents,
} from '@/services';
import listCardSetup from '@/tools/listCardSetup';

const Competence = namespace(STORE_MODULE_NAME);
const actions = mapActions(STORE_MODULE_NAME, [INIT]);
const fetch = actions[INIT];

@Component({
  components: {
    AppText,
    AppList,
    PageError,
    AppPicture,
    AppHeading,
    ExtraLayout,
    AppTypeIcon,
    AppCardsList,
    AppHtmlRender,
    AppBlockWrapper,
    BreadcrumbsLayout,
    AppCardTotalLayout,
    AppCardDescriptionBlockLayout,
  },

  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,

  metaInfo(): MetaInfo {
    const { competence } = this.$store.state.competence;
    return {
      title: (competence && competence.name) || '',
    };
  },
})
export default class CompetenceCard extends Mixins(breadcrumbsMixin) {
  @Competence.State nothingFound: boolean;
  @Competence.State programs: ParsedEvents;
  @Competence.State competenceModules: Array<string>;
  @Competence.State professions: MapedProfessionsType;

  @Competence.State(({ competence }) => competence.id) id: string;
  @Competence.State(({ competence }) => competence.name) name: string;
  @Competence.State(({ competence }) => competence.image) image: string;
  @Competence.State(({ competence }) => competence.main) main: CompetenceMain;
  @Competence.State(({ competence }) => competence.sidebar)
  sidebar: CompetenceSidebar;

  @State competencesBlocks: DictionaryType;

  get listOfCards(): Array<Object> {
    const { professions, programs } = this;
    return [
      ...listCardSetup(PROFESSION_TITLE, PROFESSION_CARD, professions),
      ...listCardSetup(PROGRAM_TITLE, PROGRAM_CARD, programs),
    ];
  }

  get crumbs() {
    const { name, breadcrumbs } = this;
    if (!name) return breadcrumbs;
    return breadcrumbs.concat([{ text: name }]);
  }

  get competenceBlockName(): string {
    const { competencesBlocks, sidebar } = this;
    return nameFromDictionary(
      competencesBlocks,
      sidebar && sidebar.compBlockId,
    );
  }

  asyncData({ store, route }: Context): Promise<any> {
    const context = { $store: store };
    const params = {
      ...route.query,
      ...route.params,
    };

    return fetch.call(context, params.id);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/competences/card/CompetenceCard.vue